import { combineReducers } from 'redux';
import contentHomeReducer from './contentHomeReducer';

export default combineReducers({
    content: contentHomeReducer
});
